function getParameterByName(name) {
    name = name.replace(/[\[]/, "\\[").replace(/[\]]/, "\\]");
    var regex = new RegExp("[\\?&]" + name + "=([^&#]*)"),
        results = regex.exec(location.search);
    return results === null ? "" : decodeURIComponent(results[1].replace(/\+/g, " "));
}


function CheckoutChargify(){
    
  var variant = getParameterByName('variant');
  	switch (parseInt(variant)){
    case 1544353793:
        window.location = "https://payments.sockpanda.com/?product=3705234#shipping_information";
        break;
    case 2749367873:
        window.location = "https://payments.sockpanda.com/?product=3705235#shipping_information";
        break;
    
    case 2749373825:
        window.location = "https://payments.sockpanda.com/?product=3705238#shipping_information";
        break;
             
    case 3106823041:
        window.location = "https://payments.sockpanda.com/?product=3705240#shipping_information";
        break;
    
    case 2748464193:
        window.location = "https://payments.sockpanda.com/?product=3705242#shipping_information";
        break;
             
    case 2748609857:
        window.location = "https://payments.sockpanda.com/?product=3705244#shipping_information";
        break;
    
    
    case 1544353729:
        window.location = "https://payments.sockpanda.com/?product=3705246#shipping_information";
        break;
             
             
    case 2749326657:
        window.location = "https://payments.sockpanda.com/?product=3705248#shipping_information";
        break;

    case 2749345409:
        window.location = "https://payments.sockpanda.com/?product=3705249#shipping_information";
        break;
             
    case 1544353857:
        window.location = "https://payments.sockpanda.com/?product=3705250#shipping_information";
        break;
    
    case 2749390721:
        window.location = "https://payments.sockpanda.com/?product=3705251#shipping_information";
        break;
             
    case 2749399553:
        window.location = "https://payments.sockpanda.com/?product=3705327#shipping_information";
        break;
    
    
    case 2893634945:
        window.location = "https://payments.sockpanda.com/?product=3705252#shipping_information";
        break;
             
             
    case 2893635073:
        window.location = "https://payments.sockpanda.com/?product=3705253#shipping_information";
        break;
    
    
    case 2893635201:
        window.location = "https://payments.sockpanda.com/?product=3705254#shipping_information";
        break;
             
    case 2893635009:
        window.location = "https://payments.sockpanda.com/?product=3705259#shipping_information";
        break;
    
    case 2893635137:
        window.location = "https://payments.sockpanda.com/?product=3705265#shipping_information";
        break;
             
    case 2893635265:
        window.location = "https://payments.sockpanda.com/?product=3705270#shipping_information";
        break;
    
    
    case 2893635329:
        window.location = "https://payments.sockpanda.com/?product=3705273#shipping_information";
        break;
             
             
    case 2893635521:
        window.location = "https://payments.sockpanda.com/?product=3705274#shipping_information";
        break;
    
    case 2893635713:
        window.location = "https://payments.sockpanda.com/?product=3705277#shipping_information";
        break;
             
             
    case 2893635393:
        window.location = "https://payments.sockpanda.com/?product=3705279#shipping_information";
        break;
    
    case 2893635649:
        window.location = "https://payments.sockpanda.com/?product=3705280#shipping_information";
        break;
             
             
    case 2893635841:
        window.location = "https://payments.sockpanda.com/?product=3705326#shipping_information";
        break;
    
    case 3349858433:
        window.location = "https://payments.sockpanda.com/?product=3705239#shipping_information";
        break;
             
             
    case 3349858561:
        window.location = "https://payments.sockpanda.com/?product=3705243#shipping_information";
        break;
    
    case 3349858625:
        window.location = "https://payments.sockpanda.com/?product=3705245#shipping_information";
        break;
             
             
    case 3349858753:
        window.location = "https://payments.sockpanda.com/?product=3705247#shipping_information";
        break;
    
    case 3349858881:
        window.location = "https://payments.sockpanda.com/?product=3705276#shipping_information";
        break;
             
             
    case 3349858945:
        window.location = "https://payments.sockpanda.com/?product=3705278#shipping_information";
        break;
    
    case 3349859073:
        window.location = "https://payments.sockpanda.com/?product=3705286#shipping_information";
        break;
             
             
    case 3349859201:
        window.location = "https://payments.sockpanda.com/?product=3705288#shipping_information";
        break;
    
    case 3349859265:
        window.location = "https://payments.sockpanda.com/?product=3705289#shipping_information";
        break;
             
             
    case 3349859393:
        window.location = "https://payments.sockpanda.com/?product=3705292#shipping_information";
        break;
    
    case 3349859457:
        window.location = "https://payments.sockpanda.com/?product=3705294#shipping_information";
        break;
             
             
    case 3349859521:
        window.location = "https://payments.sockpanda.com/?product=3705295#shipping_information";
        break;
    
             
    case 3349792001:
        window.location = "https://payments.sockpanda.com/?product=3705298#shipping_information";
        break;
    
    case 3349792065:
        window.location = "https://payments.sockpanda.com/?product=3705301#shipping_information";
        break;
             
             
    case 3349791745:
        window.location = "https://payments.sockpanda.com/?product=3705303#shipping_information";
        break;
    
    case 3349791617:
        window.location = "https://payments.sockpanda.com/?product=3705306#shipping_information";
        break;
             
             
    case 3349791681:
        window.location = "https://payments.sockpanda.com/?product=3705308#shipping_information";
        break;
    
    
    case 3349791937:
        window.location = "https://payments.sockpanda.com/?product=3705198#shipping_information";
        break;
             
             
    case 3349791809:
        window.location = "https://payments.sockpanda.com/?product=3705193#shipping_information";
        break;
    
    case 3349791873:
        window.location = "https://payments.sockpanda.com/?product=3705191#shipping_information";
        break;
             
             
    case 3349792193:
        window.location = "https://payments.sockpanda.com/?product=3705189#shipping_information";
        break;
    
    case 3349792193:
        window.location = "https://payments.sockpanda.com/?product=3705185#shipping_information";
        break;
             
             
    case 3349792257:
        window.location = "https://payments.sockpanda.com/?product=3705183#shipping_information";
        break;
    
    
    case 1544353921:
        window.location = "https://payments.sockpanda.com/?product=3705316#shipping_information";
        break;
             
             
    case 2749455873:
        window.location = "https://payments.sockpanda.com/?product=3705317#shipping_information";
        break;
    
    case 2749479873:
        window.location = "https://payments.sockpanda.com/?product=3705314#shipping_information";
        break;
             
             
    case 3349792513:
        window.location = "https://payments.sockpanda.com/?product=3705175#shipping_information";
        break;
    
    case 3349792385:
        window.location = "https://payments.sockpanda.com/?product=3705174#shipping_information";
        break;
             
             
    case 3349792449:
        window.location = "https://payments.sockpanda.com/?product=3705173#shipping_information";
        break;    

    
    case 2893636097:
        window.location = "https://payments.sockpanda.com/?product=3705307#shipping_information";
        break;
             
             
    case 2893636225:
        window.location = "https://payments.sockpanda.com/?product=3705305#shipping_information";
        break;
    
    case 2893636353:
        window.location = "https://payments.sockpanda.com/?product=3705300#shipping_information";
        break;
             
             
    case 3349859585:
        window.location = "https://payments.sockpanda.com/?product=3705169#shipping_information";
        break;
    
    case 3349859649:
        window.location = "https://payments.sockpanda.com/?product=3705166#shipping_information";
        break;
             
             
    case 3349859713:
        window.location = "https://payments.sockpanda.com/?product=3705164#shipping_information";
        break;    
    
    
    case 2894795329:
        window.location = "https://payments.sockpanda.com/?product=3704974#shipping_information";
        break;
             
             
    case 3349775937:
        window.location = "https://payments.sockpanda.com/?product=3704975#shipping_information";
        break;
    
    case 2894795585:
        window.location = "https://payments.sockpanda.com/?product=3704976#shipping_information";
        break;
             
             
    case 3349776193:
        window.location = "https://payments.sockpanda.com/?product=3704978#shipping_information";
        break;
    
    case 2894795841:
        window.location = "https://payments.sockpanda.com/?product=3704977#shipping_information";
        break;
             
             
    case 3349776449:
        window.location = "https://payments.sockpanda.com/?product=3704979#shipping_information";
        break;        
    
    
    case 34702194311302:
        window.location = "https://payments.sockpanda.com/?product=3704980#shipping_information";
        break;
        
    case 34702194409606:
        window.location = "https://payments.sockpanda.com/?product=3769101#shipping_information";
        break;
    
    case 34702194442374:
        window.location = "https://payments.sockpanda.com/?product=3780177#shipping_information";
        break;
             
             
    case 3349776705:
        window.location = "https://payments.sockpanda.com/?product=3704981#shipping_information";
        break;
           
    case 3349776769:
        window.location = "https://payments.sockpanda.com/?product=3780180#shipping_information";
        break;
           
    case 12029662465:
        window.location = "https://payments.sockpanda.com/?product=3780181#shipping_information";
        break;
        
        
    case 2894795201:
        window.location = "https://payments.sockpanda.com/?product=3704982#shipping_information";
        break;
             
             
    case 3349775809:
        window.location = "https://payments.sockpanda.com/?product=3704983#shipping_information";
        break;
    
    case 2894795457:
        window.location = "https://payments.sockpanda.com/?product=3704984#shipping_information";
        break;
             
             
    case 3349776065:
        window.location = "https://payments.sockpanda.com/?product=3704985#shipping_information";
        break;        
    
    
    case 2894795713:
        window.location = "https://payments.sockpanda.com/?product=3704986#shipping_information";
        break;
             
             
    case 3349776321:
        window.location = "https://payments.sockpanda.com/?product=3704987#shipping_information";
        break;
    
    case 34699420401798:
        window.location = "https://payments.sockpanda.com/?product=3704988#shipping_information";
        break;
    
    case 34699420467334:
        window.location = "https://payments.sockpanda.com/?product=3780178#shipping_information";
        break;
    
    case 34699420500102:
        window.location = "https://payments.sockpanda.com/?product=3780179#shipping_information";
        break;
             
    case 3349776577:
        window.location = "https://payments.sockpanda.com/?product=3704990#shipping_information";
        break; 
           
   case 3349776641:
        window.location = "https://payments.sockpanda.com/?product=3780182#shipping_information";
        break; 
           
   case 12029659137:
        window.location = "https://payments.sockpanda.com/?product=3780183#shipping_information";
        break; 
        
        
    
    case 3349792129:
        window.location = "https://payments.sockpanda.com/?product=3705297#shipping_information";  
        break;
    
    case 3349792321:
		window.location = "https://payments.sockpanda.com/?product=3705250#shipping_information";  
        break;
    
   case 11436985281:
		window.location = "https://payments.sockpanda.com/?product=3773903#shipping_information";  
        break;
    
   case 11436990721:
		window.location = "https://payments.sockpanda.com/?product=3773904#shipping_information";  
        break;
        
    // Three Months -----------------------------------------------------------------------------
    
    // Men

    // Crazy
    case 13832197767213:
        window.location = "https://payments.sockpanda.com/?product=4729945#shipping_information";  
        break;
    
    case 13832198324269:
        window.location = "https://payments.sockpanda.com/?product=4729948#shipping_information";  
        break;

    // Normal
    case 13832199569453:
        window.location = "https://payments.sockpanda.com/?product=4729938#shipping_information";  
        break;
    
    case 13832199634989:
        window.location = "https://payments.sockpanda.com/?product=4729949#shipping_information";  
        break;  

    // Both
    case 13832211333165:
        window.location = "https://payments.sockpanda.com/?product=4730029#shipping_information";  
        break;  

    // Women
    
    // Crazy
    case 13832238792749:
        window.location = "https://payments.sockpanda.com/?product=4729946#shipping_information";  
        break;
    case 13832238891053:
        window.location = "https://payments.sockpanda.com/?product=4729951#shipping_information";  
        break;
    
    // Normal
    case 13832237875245:
        window.location = "https://payments.sockpanda.com/?product=4729941#shipping_information";  
        break;
    case 13832238497837:
        window.location = "https://payments.sockpanda.com/?product=4729950#shipping_information";  
        break;
    
    // Both
    case 13832240005165:
        window.location = "https://payments.sockpanda.com/?product=4730030#shipping_information";  
        break;
    
    // Tweens (Large)
    
    // Boys
    case 34699420434566:
        window.location = "https://payments.sockpanda.com/?product=4729954#shipping_information";  
        break;
    
    // Girls
    case 34702194376838:
        window.location = "https://payments.sockpanda.com/?product=4729955#shipping_information";  
        break;

    // Boys
    // Medium
    case 13832285454381:
        window.location = "https://payments.sockpanda.com/?product=4730040#shipping_information";  
        break;
    // Small
    case 13832284602413:
        window.location = "https://payments.sockpanda.com/?product=4730042#shipping_information";  
        break;
    
    // Girls
    // Medium
    case 13832286634029:
        window.location = "https://payments.sockpanda.com/?product=4730041#shipping_information";  
        break;
    // Small
    case 13832284635181:
        window.location = "https://payments.sockpanda.com/?product=4729953#shipping_information";  
        break;
    
    
    // Panda Pals Subscriptions Below
        

	case 10634069889:
		window.location = "https://payments.sockpanda.com/?product=3796719&firstname=" + $("#firstname").val() + "&lastname=" + $("#lastname").val();  
        break;        
        
	case 10634069953:
		window.location = "https://payments.sockpanda.com/?product=3796737&firstname=" + $("#firstname").val() + "&lastname=" + $("#lastname").val();  
        break;        
        
	case 10634070017:
		window.location = "https://payments.sockpanda.com/?product=3796728&firstname=" + $("#firstname").val() + "&lastname=" + $("#lastname").val();  
        break;        
        
	case 10634070081:
		window.location = "https://payments.sockpanda.com/?product=3796740&firstname=" + $("#firstname").val() + "&lastname=" + $("#lastname").val();  
        break;        
        
        
	case 10634070145:
		window.location = "https://payments.sockpanda.com/?product=3796749&firstname=" + $("#firstname").val() + "&lastname=" + $("#lastname").val();  
        break;        
        
	case 10634070273:
		window.location = "https://payments.sockpanda.com/?product=3796753&firstname=" + $("#firstname").val() + "&lastname=" + $("#lastname").val();  
        break;                
                
	case 10634070337:
		window.location = "https://payments.sockpanda.com/?product=3796751&firstname=" + $("#firstname").val() + "&lastname=" + $("#lastname").val();  
        break;        
        
	case 10634070401:
		window.location = "https://payments.sockpanda.com/?product=3796756&firstname=" + $("#firstname").val() + "&lastname=" + $("#lastname").val();  
        break;     
                
        
	case 10634070465:
		window.location = "https://payments.sockpanda.com/?product=3796743&firstname=" + $("#firstname").val() + "&lastname=" + $("#lastname").val();  
        break;        
        
	case 10634070529:
		window.location = "https://payments.sockpanda.com/?product=3796745&firstname=" + $("#firstname").val() + "&lastname=" + $("#lastname").val();  
        break;                
                
	case 10634070593:
		window.location = "https://payments.sockpanda.com/?product=3796758&firstname=" + $("#firstname").val() + "&lastname=" + $("#lastname").val();  
        break;        
        
	case 10634070657:
		window.location = "https://payments.sockpanda.com/?product=3796760&firstname=" + $("#firstname").val() + "&lastname=" + $("#lastname").val();  
        break;             
                    
    // Three Months GIFT -----------------------------------------------------------------------------
    
    // Men

    // Crazy
    case 13959320797229:
        window.location = "https://payments.sockpanda.com/?product=4752779#shipping_information";  
        break;
    
    case 13959321550893:
        window.location = "https://payments.sockpanda.com/?product=4752780#shipping_information";  
        break;

    // Normal
    case 13959312736301:
        window.location = "https://payments.sockpanda.com/?product=4752777#shipping_information";  
        break;
    
    case 13959320600621:
        window.location = "https://payments.sockpanda.com/?product=4752778#shipping_information";  
        break;  

    // Both
    case 13959321681965:
        window.location = "https://payments.sockpanda.com/?product=4752783#shipping_information";  
        break;  

    // Women
    
    // Crazy
    case 13959325810733:
        window.location = "https://payments.sockpanda.com/?product=4752786#shipping_information";  
        break;
    case 13959327219757:
        window.location = "https://payments.sockpanda.com/?product=4752787#shipping_information";  
        break;
    
    // Normal
    case 13959324106797:
        window.location = "https://payments.sockpanda.com/?product=4752784#shipping_information";  
        break;
    case 13959325057069:
        window.location = "https://payments.sockpanda.com/?product=4752785#shipping_information";  
        break;
    
    // Both
    case 13959328694317:
        window.location = "https://payments.sockpanda.com/?product=4752789#shipping_information";  
        break; 
        
     
    // Tweens
    // Girls
    case 13959347830829:
        window.location = "https://payments.sockpanda.com/?product=4752790#shipping_information";  
        break;
    // Boys
    case 13959347634221:
        window.location = "https://payments.sockpanda.com/?product=4752791#shipping_information";  
        break;
    
    // Gift boxes ----------------------------------
        
    // Men
    // Crazy
    case 13975285334061:
        window.location = "https://payments.sockpanda.com/?product=4755754#shipping_information";  
        break; 
    // Conservative
    case 13975305486381:
        window.location = "https://payments.sockpanda.com/?product=4755753#shipping_information";  
        break; 
    // Both
    case 13975305551917:
        window.location = "https://payments.sockpanda.com/?product=4755755#shipping_information";  
        break; 
        
    // Women
    // Crazy
    case 13975305453613:
        window.location = "https://payments.sockpanda.com/?product=4755756#shipping_information";  
        break; 
    // Conservative
    case 13975305519149:
        window.location = "https://payments.sockpanda.com/?product=4755757#shipping_information";  
        break; 
    // Both
    case 13975305584685:
        window.location = "https://payments.sockpanda.com/?product=4755758#shipping_information";  
        break; 
    
    // Tween
    // Boy
    case 13975305650221:
        window.location = "https://payments.sockpanda.com/?product=4755759#shipping_information";  
        break; 
    // Girl
    case 13975305682989:
        window.location = "https://payments.sockpanda.com/?product=4755760#shipping_information";  
        break; 
    
    // Kids Medium
    // Boy
    case 13975305715757:
        window.location = "https://payments.sockpanda.com/?product=4755761#shipping_information";  
        break; 
    // Girl
    case 13975305748525:
        window.location = "https://payments.sockpanda.com/?product=4755762#shipping_information";  
        break; 
        
    // Kids Small
    // Boy
    case 13975305781293:
        window.location = "https://payments.sockpanda.com/?product=4755763#shipping_information";  
        break; 
    // Girl
    case 13975305814061:
        window.location = "https://payments.sockpanda.com/?product=4755764#shipping_information";  
        break; 

     // Seasonal Quarterly Subscriptions 
     
     // Kids 3-5 Male
    case 29556400357421:
        window.location = "https://payments.sockpanda.com/?product=4952229#shipping_information";  
        break; 
    // Kids 3-5 FeMale
    case 29556400390189:
        window.location = "https://payments.sockpanda.com/?product=4952230#shipping_information";  
        break; 

    // Kids 6-8 Male
    case 29556400422957:
        window.location = "https://payments.sockpanda.com/?product=4952231#shipping_information";  
        break; 

    // Kids 6-8 FeMale
    case 29556400455725:
        window.location = "https://payments.sockpanda.com/?product=4952232#shipping_information";  
        break;

    // Kids 8-11 Male
    case 29556400488493:
        window.location = "https://payments.sockpanda.com/?product=4952233#shipping_information";  
        break;

    // Kids 8-11 FeMale
    case 29556400521261:
        window.location = "https://payments.sockpanda.com/?product=4952234#shipping_information";  
        break;

    // Adult Male   
    case 29556400554029:
        window.location = "https://payments.sockpanda.com/?product=4952235#shipping_information";  
        break;

    // Adult FeMale   
    case 29556400586797:
        window.location = "https://payments.sockpanda.com/?product=4952236#shipping_information";  
        break;        
        
    default:
        alert("this variant hasn't been created yet in Chargify"); 
	}
  
}

function SelectSubscription(myMonths){
    $('.recurring_div label input').click();
    
    $('.frequency_num').val(myMonths).trigger('change');
    
    $('.frequency_num').change(function(){
      $('.frequency_num').val(myMonths);
    });
    
}
  
function changeSelected(myMonths){
   
    $("#ProductSelect-option-2").val(myMonths).trigger('change');
    
    $("#ProductSelect-option-2").change(function(){
      $("#ProductSelect-option-2").val(myMonths);
    });
    
    
    $("#myVariantID").val(Shopify.urlParam("variant"));
  
    
     $("#ProductSelect").val(Shopify.urlParam("variant")).trigger('change');
    
    $("#ProductSelect").change(function(){
      $("#ProductSelect").val(Shopify.urlParam("variant"));
    });
    
    var variant = getParameterByName('variant');
    
    var myFunctionName = "updatePrice_" + variant;    
}
  

  
$( document ).ready(function() {    
    
    var myPage = window.location.href;
    
    if(myPage.indexOf("womens-socks") > -1) {
       $("#women-selection").show();
    }else if(myPage.indexOf("kids-socks") > -1){
       $("#kids-selection").show(); 
      SetOption('ProductSelect-option-2', '1 Month');
    }else if(myPage.indexOf("mens-socks") > -1){
       $("#men-selection").show();
    }else if(myPage.indexOf("panda-pals-socks") > -1){
      $('#panda-pals-selection').show();
      SetOption('ProductSelect-option-1', 'Both');
      SetOption('ProductSelect-option-2', '1 Month');
    }else if(myPage.indexOf("gift-sets") > -1){
      $("#main-selection").show();
      // Gift box
      $('#selection-section-gender').hide()
      $('#selection-section-women-style').hide()
      $('#selection-section-men-style').hide()
    }
         
    if(myPage.indexOf("-gift") > -1) {
      
      $('#myStyleTitle').html('Pick A Style');
      $('#myStyleTitleWomen').html('Pick A Style');
      
    }else{
      $('#myStyleTitle').html('Which style will the recipient rock out?');
      $('#myStyleTitleWomen').html('Which style will the recipient rock out?');
      
    }
  	
    
    
});
  
  
  function SetOption(myOptionID, myOptionValue){
   
    $("#" + myOptionID).val(myOptionValue).trigger('change');
    
    $("#" + myOptionID).change(function(){
      $("#" + myOptionID).val(myOptionValue);
    });
    $("#myVariantID").val(Shopify.urlParam("variant"));

    $("#" + myOptionID).val(myOptionValue).trigger('change');
    
    $("#" + myOptionID).change(function(){
      $("#" + myOptionID).val(myOptionValue);
    });
    $("#myVariantID").val(Shopify.urlParam("variant"));
  }
  
  
  function RetrieveTotal(){
    $("#myCheckout").html("CHECKOUT (" + $('#ProductPrice').html() + ")");
  }
  
  
  
  function RetrieveTotalWomen(){
    $("#myCheckoutWomen").html("CHECKOUT (" + $('#ProductPrice').html() + ")");
  }
  
  
  function RetrieveTotalKids(){
    $("#myCheckoutKids").html("CHECKOUT (" + $('#ProductPrice').html() + ")");
  }

function RetrieveTotalPandaPals(){
    $("#myCheckoutPandaPals").html("CHECKOUT (" + $('#ProductPrice').html() + ")");
  }



/*
  function RetrieveTotalPanda(){
    $("#myCheckoutPanda").html("CHECKOUT (" + $('#ProductPrice').html() + ")");
  }
  
*/ 

function ClearGiftSelections(){
	document.getElementById("men-gift-yes").className = "selection-2-cols";
	document.getElementById("men-gift-no").className = "selection-2-cols";	
}
  
  
function ClearGiftSelectionsWomen(){
	document.getElementById("women-gift-yes").className = "selection-2-cols";
	document.getElementById("women-gift-no").className = "selection-2-cols";	
}
  

function ClearGiftSelectionsKids(){
	document.getElementById("kids-gift-yes").className = "selection-2-cols";
	document.getElementById("kids-gift-no").className = "selection-2-cols";	
}  
  

function ClearMenStyleSelections(){
	document.getElementById("men-style-stylish").className = "selection-1-col";
	document.getElementById("men-style-bold").className = "selection-1-col";		
	document.getElementById("men-style-both").className = "selection-1-col";
	
	document.getElementById("men-section-style-highlight-stylish").className = "";
	document.getElementById("men-section-style-highlight-bold").className = "";	
	document.getElementById("men-section-style-highlight-both").className = "";	

}
  
  
function ClearWomenStyleSelections(){
	document.getElementById("women-style-patterns").className = "selection-1-col";
	document.getElementById("women-style-wild").className = "selection-1-col";		
	document.getElementById("women-style-both").className = "selection-1-col";
	
	document.getElementById("women-section-style-highlight-patterns").className = "";
	document.getElementById("women-section-style-highlight-wild").className = "";	
	document.getElementById("women-section-style-highlight-both").className = "";	

}  

function ClearPairsSelections(){

	document.getElementById("2-pairs").className = "selection-2-cols";	
	document.getElementById("1-pair").className = "selection-2-cols";	
	
}
  
function ClearPairsSelectionsWomen(){

	document.getElementById("2-pairs-women").className = "selection-2-cols";	
	document.getElementById("1-pair-women").className = "selection-2-cols";	
	
}
  
  
function ClearSizesSelectionsKids(){

	document.getElementById("size-small").className = "selection-3-cols";	
	document.getElementById("size-medium").className = "selection-3-cols";	  
	document.getElementById("size-large").className = "selection-3-cols";	  
	
}


function ClearSizesSelectionsPandaPals(){

  	document.getElementById("size-panda-pals-small").className = "selection-2-cols";	
	document.getElementById("size-panda-pals-medium").className = "selection-2-cols";	  

	
}


function ClearDurationSelections(){

	document.getElementById("1-month").className = "selection-3-cols";	
	document.getElementById("3-months").className = "selection-3-cols";	
  	document.getElementById("6-months").className = "selection-3-cols";	
	document.getElementById("12-months").className = "selection-3-cols";		
	
}

function ClearSizeSelections(){

	document.getElementById("size-adult").className = "selection-2-cols";	
	document.getElementById("size-tween").className = "selection-2-cols";	
  	document.getElementById("size-medium").className = "selection-2-cols";
	document.getElementById("size-small").className = "selection-2-cols";
}

function ClearGenderSelections(){

	document.getElementById("gender-male").className = "selection-2-cols";	
	document.getElementById("gender-female").className = "selection-2-cols";
}
   
function ClearDurationSelectionsWomen(){

	document.getElementById("1-month-women").className = "selection-3-cols";	
	document.getElementById("3-months-women").className = "selection-3-cols";	
	document.getElementById("6-months-women").className = "selection-3-cols";	
	document.getElementById("12-months-women").className = "selection-3-cols";		
	
}
  
  
function ClearDurationSelectionsKids(){

	document.getElementById("1-month-kids").className = "selection-3-cols";	
  	document.getElementById("3-months-kids").className = "selection-3-cols";	
	document.getElementById("6-months-kids").className = "selection-3-cols";
    document.getElementById("12-months-kids").className = "selection-3-cols";	
}


function ClearDurationSelectionsPandaPals(){

	document.getElementById("1-month-panda-pals").className = "selection-3-cols";	
	document.getElementById("3-months-panda-pals").className = "selection-3-cols";
  	document.getElementById("6-months-panda-pals").className = "selection-3-cols";
    document.getElementById("12-months-panda-pals").className = "selection-3-cols";	
}


  

function ClearSelectionsKidsGender(){

	document.getElementById("gender-boys").className = "selection-2-cols";	
	document.getElementById("gender-girls").className = "selection-2-cols";	
	
}  


function ClearSelectionsPandaPalsGender(){

  
  	document.getElementById("gender-panda-pals-boys").className = "selection-2-cols";	
	document.getElementById("gender-panda-pals-girls").className = "selection-2-cols";	
	
}  


  

function showSection(mySection){
	document.getElementById(mySection).style.display = 'block';	
}

function hideSection(mySection){
	document.getElementById(mySection).style.display = 'none';	
}


function showMenStylesWithoutSliding(){
	
	$("#selection-section-men-style").fadeIn(500);
	
	
}  
  
function showMenStyles(myPosition,event){
	
	$("#selection-section-men-style").show();
	
	 $('body,html').animate({
                        scrollTop: $("#" + myPosition).offset().top
                    }, 1000);  
    event.preventDefault();
	
}

function showWomenStyles(myPosition,event){
	
	$("#selection-section-women-style").fadeIn(500);
	
	 $('#selection-section-women-style, body').animate({
                        scrollTop: $("#" + myPosition).offset().top
                    }, 1000);
  
  event.preventDefault();
	
}  

function showPairs(event){
	
	$("#selection-section-pairs").show();
  
	$('body,html').animate({
                        scrollTop: $("#selection-section-pairs").offset().top       					
                    }, 1000);
  
    event.preventDefault();
}

function ShowGenders(event, age){
	
	$("#selection-section-gender").show();
  
    if (age === 'child') {
      $('#gender-male').html('BOY')
      $('#gender-female').html('GIRL')
    } else {
      $('#gender-male').html('MAN')
      $('#gender-female').html('WOMAN')
    }
  
	$('body,html').animate({
      scrollTop: $("#selection-section-gender").offset().top       					
    }, 1000);
  
    event.preventDefault();
}
 
function ShowGenderStyles(event){
	
	var size = $("#ProductSelect-option-0").val()
	var gender = $("#ProductSelect-option-1").val()
    var el
    console.log(size);
    console.log(gender);
    if (size === 'Adult' && gender === 'Male') {
      el = '#selection-section-men-style'
    } else if (size === 'Adult' && gender === 'Female') {
      el = '#selection-section-women-style'
    } else {
      SetOption('ProductSelect-option-2', 'Both');
    }
    $('#selection-section-men-style').hide();
    $('#selection-section-women-style').hide();
    if (el) {
      $(el).show();
      $('body,html').animate({
        scrollTop: $(el).offset().top       					
      }, 1000);
    }
  
    event.preventDefault();
}
  
function showPairsWomen(event){
	
	$("#selection-section-pairs-women").fadeIn(500);
  

	 $('#selection-section-pairs-women, body,html').animate({
                        scrollTop: $("#selection-section-pairs-women").offset().top       					
                    }, 1000);
  
  event.preventDefault();
	
}  



function showMonths(){
	
	$("#selection-section-months").fadeIn(500);
  
  
	 $('html, body').animate({
                        scrollTop: $("#selection-section-months").offset().top
                    }, 1000);
  	
}
 
  
function showMonthsWomen(event){
	
	$("#selection-section-months-women").fadeIn(500);
  
  
	 $('#selection-section-months-women, html, body').animate({
                        scrollTop: $("#selection-section-months-women").offset().top
                    }, 1000);
  
  event.preventDefault();
	
}
  

function showKidsSizes(event){
// Old Code used to show sizes
// Kids section is replaced by Tweens section (default size is 9-11)
// 	$("#selection-section-kids-sizes").fadeIn(500); 
// 	 $('#selection-section-kids-sizes, body').animate({
//                         scrollTop: $("#selection-section-kids-sizes").offset().top
//                     }, 1000);
  SetOption('ProductSelect-option-0', 'Large');
  RetrieveTotalKids(); 
  showCheckoutKids();
  event.preventDefault();
	
}


function showPandaPalsSizes(event){

  
  	RetrieveTotalPandaPals(); 
	$("#selection-section-panda-pals-sizes").fadeIn(500);
  
  
	 $('#selection-section-panda-pals-sizes, body,html').animate({
                        scrollTop: $("#selection-section-panda-pals-sizes").offset().top
                    }, 1000);
  
  event.preventDefault();  
  
	
}

  
function showKidsGenders(event){
	
	$("#selection-section-gender").fadeIn(500);
  
  
	 $('#selection-section-gender, body').animate({
                        scrollTop: $("#selection-section-gender").offset().top
                    }, 1000);
  
  event.preventDefault();
	
}


function showPandaPalsGenders(event){
	
	$("#selection-section-gender-panda-pals").fadeIn(500);
  
  
	 $('#selection-section-gender-panda-pals, body').animate({
                        scrollTop: $("#selection-section-gender-panda-pals").offset().top
                    }, 1000);
  
  event.preventDefault();
	
}


  
function showMonthsKids(event){
	SetOption('ProductSelect-option-0', 'Large');
  	RetrieveTotalKids(); 
	$("#selection-section-months-kids").fadeIn(500);
  
  
	 $('body,html').animate({
                        scrollTop: $("#selection-section-months-kids").offset().top
                    }, 1000);
  
  event.preventDefault();
	
}


function showPandaPalsMonths(event){
	
  
  //SetOption('ProductSelect-option-0', 'Large');
  	RetrieveTotalPandaPals(); 

  	$("#selection-section-panda-pals-months").fadeIn(500);
  
  
	 $('#selection-section-panda-pals-months, body,html').animate({
                        scrollTop: $("#selection-section-panda-pals-months").offset().top
                    }, 1000);
  
  event.preventDefault();
	
}


function selectStyle (gender, style){
  document.getElementById(gender + "-style-Crazy").className = "selection-1-col";
  document.getElementById(gender + "-style-Conservative").className = "selection-1-col";		
  document.getElementById(gender + "-style-Both").className = "selection-1-col";

  document.getElementById(gender + "-section-style-highlight-Crazy").className = "";
  document.getElementById(gender + "-section-style-highlight-Conservative").className = "";	
  document.getElementById(gender + "-section-style-highlight-Both").className = "";	
  
  document.getElementById(gender + '-style-' + style).className = 'selection-1-col selection-highlighted';
  document.getElementById(gender + '-section-style-highlight-' + style).className = gender + '-section-style highlight-style-selection';
  SetOption('ProductSelect-option-2', style);
  RetrieveTotal();
  showCheckout();
}

function showCheckout(){
  $("#selection-section-checkout").fadeIn(500);
}
  
  
function showCheckoutWomen(){
  $("#selection-section-checkout-women").fadeIn(500);
}
  
  
function showCheckoutKids(){
  SetOption('ProductSelect-option-0', 'Large');
  RetrieveTotalKids();
  $("#selection-section-checkout-kids").fadeIn(500);
}  


function showCheckoutPandaPals(){
  
  //SetOption('ProductSelect-option-0', 'Large');
  
  RetrieveTotalPandaPals();
  $("#selection-section-checkout-panda-pals").fadeIn(500);
}  

/*

function showCheckoutPanda(){
  RetrieveTotalPanda(); 
  $("#selection-section-checkout-panda").fadeIn(500);  
}

*/

